import type { TCatalogNavigation, TFilterItem, TProductItem, TSortItem } from '~/layers/catalog/data/types'

import { defineStore } from 'pinia'

export const useCatalogGridStore = defineStore('catalogGridStore', {
  state: () => ({
    items: [] as TProductItem[],
    filters: [] as TFilterItem[],
    sorting: [] as TSortItem[],
    navigation: {
      page: 0,
      perPage: 0,
      total: 0,
      lastPage: 0,
      isLastPage: true,
    } as TCatalogNavigation,
    pageTitle: '',
  }),
  actions: {
    pushItem(item: TProductItem): void {
      this.items.push(item)
    },
    clearItems(): void {
      this.items.splice(0)
    },
    pushFilter(filter: TFilterItem): void {
      this.filters.push(filter)
    },
    clearFilters(): void {
      this.filters.splice(0)
    },
    pushSorting(sortItem: TSortItem): void {
      this.sorting.push(sortItem)
    },
    clearSorting(): void {
      this.sorting.splice(0)
    },
    setNavigation(navigation: TCatalogNavigation): void {
      this.navigation = navigation
    },
    setPageTitle(title: string): void {
      this.pageTitle = title
    },
    reset(): void {
      this.items.splice(0)
      this.filters.splice(0)
      this.sorting.splice(0)
      this.navigation = {
        page: 0,
        perPage: 0,
        total: 0,
        lastPage: 0,
        isLastPage: true,
      }
      this.pageTitle = ''
    },
  },
})
